<template>
    <div class="header-basket">
        <div class="bordered light shadowed pad bg--white">
            <div class="cart-progress">
                <span class="one active"></span>
                <span class="two active"></span>
                <span class="three active"></span>
            </div>
            <h5 class="text-right pad-top">Summary</h5>
            <hr />
            <div
                v-for="(item, index) in basketContents"
                v-bind:key="index"
                class="grid-x">
                <div class="cell small-12 medium-3">
                    <img
                        v-bind:src="`https://our-catalogue.com/RUNS/images/${item.product_code}.jpg?width=100`"
                        alt="" />
                </div>
                <div class="cell small-12 medium-6">
                    <p class="small text-light pad-left">
                        {{ item.product_code }}
                    </p>
                    <p class="small text-light pad-left">
                        Colour <span class="float-right">{{ item.colour }}</span><br />
                        Size<br />
                        <span
                            v-for="(size, index) in item.size"
                            v-bind:key="index"
                            class="text-heavy">
                            {{ size }}<br />
                        </span>
                        Method <span class="float-right text-capitalize">{{ item.method }}</span><br />
                        Customize <span class="float-right">{{ item.design_id }}</span><br />
                    </p>
                </div>
                <div class="cell small-12 medium-3">
                    <p class="text-right">
                        &pound;{{ item.price + ( item.design_price / 100 ) | numeral('0,0.00') }} X {{ item.quantity }}
                        <i
                            v-on:click="removeFromBasket(item.basket_item_id)"
                            class="material-icons text-red link">delete</i>
                    </p>
                </div>
                <div class="cell small-12">
                    <hr />
                </div>
            </div>
            <table class="fixed">
                <tbody>
                    <tr>
                        <th>SubTotal</th>
                        <td colspan="2" class="text-right">
                            &pound;{{ basketSubTotal | numeral('0,0.00') }}
                        </td>
                    </tr>
                    <tr>
                        <th>VAT</th>
                        <td colspan="2" class="text-right">
                            &pound;{{ basketVatTotal | numeral('0,0.00') }}
                        </td>
                    </tr>
                    <tr>
                        <th>Delivery</th>
                        <td>&nbsp;</td>
                        <td class="price-cell text-right">
                            &pound;{{ deliveryPrice | numeral('0,0.00') }}
                        </td>
                    </tr>
                    <tr>
                        <th>Total</th>
                        <td colspan="2" class="text-right">
                            &pound;{{ (deliveryPrice + basketSubTotal + basketVatTotal) | numeral('0,0.00') }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <router-link
                to="/checkout/basket"
                tag="button"
                class="button tall green expanded">
                Checkout
            </router-link>
            <router-link
                to="/order/design"
                tag="button"
                class="button tall green expanded">
                Customise your clothing
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeaderBasket',
    computed: {
        basketContents() { return this.$store.getters.basketItems; },
        basketSubTotal() { return this.$store.getters.basketSubTotal; },
        deliveryPrice() { return this.$store.getters.deliveryPrice; },
        basketVatTotal() { return this.$store.getters.basketVatTotal; },
    },
    methods: {
        removeFromBasket(item) {
            this.$store.dispatch('removeFromBasket', item);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Header/HeaderBasket.vue